import { GENERIC_COMPONENTS } from './chunk-RIC2ISCZ.js';
import { ProtocolIcon } from './chunk-QJE5M5V2.js';
import { TOKEMAK_MESSAGING, TOKEMAK_COMPONENTS, pickField, TOKEMAK_FIELD_LABELS, accentForProtocol, ProtocolValue, SectionCard, FactGrid, ProtocolParamList, ProtocolBadge } from './chunk-PPWVGY7F.js';
import { MessageSquareText } from 'lucide-react';
import { displayOf } from '@authe/fe-commons/storage';
import { jsx, jsxs } from 'react/jsx-runtime';

function payloadType(event) {
  const label = displayOf(pickField(event.params, "message"));
  return typeof label === "string" && label.trim() ? label : void 0;
}
function TokemakMessage({ event, hint }) {
  const sourceChain = pickField(event.params, "sourceChainSelector", "sourceChain");
  const origin = pickField(event.params, "messageOrigin");
  const receiver = pickField(event.params, "messageReceiver", "recipient");
  const token = pickField(event.params, "token");
  const amount = pickField(event.params, "amount");
  const nonce = pickField(event.params, "messageNonce", "nonce");
  const ccipMessageId = pickField(event.params, "ccipMessageId");
  const type = payloadType(event);
  const facts = [
    {
      label: TOKEMAK_FIELD_LABELS.messageType,
      value: type ? /* @__PURE__ */ jsx(
        "span",
        {
          className: `inline-flex items-center rounded-sm px-1.5 py-px text-2xs font-medium ${accentForProtocol(TOKEMAK_MESSAGING.protocolId).badge}`,
          children: type
        }
      ) : null,
      when: type
    },
    { label: TOKEMAK_FIELD_LABELS.sourceChainSelector, value: /* @__PURE__ */ jsx(ProtocolValue, { value: sourceChain }), when: sourceChain },
    { label: TOKEMAK_FIELD_LABELS.messageOrigin, value: /* @__PURE__ */ jsx(ProtocolValue, { value: origin }), when: origin },
    { label: TOKEMAK_FIELD_LABELS.messageReceiver, value: /* @__PURE__ */ jsx(ProtocolValue, { value: receiver }), when: receiver },
    { label: TOKEMAK_FIELD_LABELS.amount, value: /* @__PURE__ */ jsx(ProtocolValue, { value: amount }), when: amount },
    { label: TOKEMAK_FIELD_LABELS.token, value: /* @__PURE__ */ jsx(ProtocolValue, { value: token }), when: token },
    { label: TOKEMAK_FIELD_LABELS.messageNonce, value: /* @__PURE__ */ jsx(ProtocolValue, { value: nonce }), when: nonce },
    { label: TOKEMAK_FIELD_LABELS.ccipMessageId, value: /* @__PURE__ */ jsx(ProtocolValue, { value: ccipMessageId }), when: ccipMessageId }
  ];
  const title = /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
    /* @__PURE__ */ jsx(ProtocolIcon, { protocolId: TOKEMAK_MESSAGING.protocolId, icon: MessageSquareText }),
    /* @__PURE__ */ jsx("span", { className: "text-sm font-semibold", children: hint.label ?? event.name ?? "Cross-chain message" })
  ] });
  return /* @__PURE__ */ jsxs(
    SectionCard,
    {
      title,
      protocolId: TOKEMAK_MESSAGING.protocolId,
      meta: /* @__PURE__ */ jsx(ProtocolBadge, { protocolId: TOKEMAK_MESSAGING.protocolId }),
      children: [
        /* @__PURE__ */ jsx(FactGrid, { facts }),
        /* @__PURE__ */ jsxs("details", { className: "mt-3 min-w-0", children: [
          /* @__PURE__ */ jsx("summary", { className: "cursor-pointer text-xs text-muted-foreground hover:text-foreground", children: "All event fields" }),
          /* @__PURE__ */ jsx("div", { className: "pt-2", children: /* @__PURE__ */ jsx(ProtocolParamList, { params: event.params, emptyLabel: "No decoded fields" }) })
        ] })
      ]
    }
  );
}

// src/protocols/tokemak_messaging/index.ts
var PID = TOKEMAK_MESSAGING.protocolId;
var TOKEMAK_MESSAGING_HINTS = {
  valueHints: [],
  eventHints: [
    {
      protocolId: PID,
      event: "MessageData",
      component: TOKEMAK_COMPONENTS.message,
      label: "Cross-chain message",
      summaryFields: ["messageType", "messageNonce", "sourceChainSelector", "messageOrigin", "message"]
    },
    {
      protocolId: PID,
      event: "MessageReceived",
      component: GENERIC_COMPONENTS.event,
      label: "Cross-chain message received",
      summaryFields: ["messageReceiver", "message"]
    }
  ],
  callHints: []
};
function registerTokemakMessaging(registry) {
  registry.registerEvent(TOKEMAK_COMPONENTS.message, TokemakMessage);
  registry.registerHints(TOKEMAK_MESSAGING_HINTS);
  return registry;
}

export { TOKEMAK_MESSAGING_HINTS, TokemakMessage, registerTokemakMessaging };
//# sourceMappingURL=chunk-WDPBWDAQ.js.map
//# sourceMappingURL=chunk-WDPBWDAQ.js.map